import apollo from '@/graphql'

import RackTypesQuery from '@/graphql/rack/RackTypesQuery.gql'
import SavePogMapping from '@/graphql/pog/SavePogMapping.gql'
import TakeLaneSidePicture from '@/graphql/lane_side/TakeLaneSidePicture.gql'

const state = {
  rackTypes: [],
}

const getters = {
  rackTypes: st => st.rackTypes,
}

const mutations = {
  setRackTypes(st, rackTypes) {
    state.rackTypes = rackTypes
  },
}

const actions = {
  loadRackTypes({ commit }) {
    apollo.defaultClient
      .watchQuery({
        query: RackTypesQuery,
      })
      .subscribe(({ data: { rackTypes } }) => {
        commit('setRackTypes', rackTypes)
      })
  },

  refreshPogMappingImage(context, { laneSidesId }) {
    return apollo.defaultClient.mutate({
      mutation: TakeLaneSidePicture,
      variables: { laneSidesId },
    })
  },

  savePogMapping(context, { variables }) {
    return apollo.defaultClient.mutate({
      mutation: SavePogMapping,
      variables,
    })
  },
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/pog/PogMapping.js